module.exports = ".exHeader {\n  height: 60px;\n}\n"